import { useContext, useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogBody, Tooltip } from '@blueprintjs/core';
import { AuthContext } from "../../utils/context/auth.context.ts";
import { AppContext } from "../../utils/context/app.context.js";
import cotizacionesService from "../../services/cotizaciones.service.js";
import FormComponent from "../../utils/components/form.component.js";
import serviciosService from "../../services/servicios.service.js";
import Vars from "../../utils/json/variables.json"


export default function CotizacionEdit(props) {
    const { id, toast, list } = props
    const [item, setItem] = useState(null)
    const [modal, setModal] = useState(false)
    const authContext = useContext(AuthContext)
    const appContext = useContext(AppContext)
    const { t } = useTranslation();
    async function get(id, set) {
        if (authContext.verify({ pathname: "/cot" }, "GET")) {
            await cotizacionesService.get(id)
                .then(res => {
                    setItem(res.data);
                    if (set) {
                        set(true);
                    }
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {

                })
        } else {
            toast.warning(t('auth.nopermit'))
        }

    }

    function edit(id, form) {
        if (authContext.verify({ pathname: "/cot" }, "PUT")) {

            toast.info(t('actions.procesing'))
            cotizacionesService.update(form, id)
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.edited'));
                    }
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    setItem(null);
                    setModal(false);
                    if (list) list();
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }

    }

    async function remove_service(id, form) {
        let remaining_services = item.services.filter(i => i.id !== id);
        let sum = 0;
        for (let i = 0; i < remaining_services.length; i++) {
            const service = remaining_services[i]
            const monto = Number(service.monto);
            const cantidad = Number(service.cantidad);
            let monto_base = (monto * cantidad)

            sum += monto_base
        }
        let new_form = { ...form }
        new_form.monto = sum;
        new_form.services = null;
        await cotizacionesService.update(new_form, item.id);

        if (authContext.verify({ pathname: "/cot" }, "DELETE")) {
            toast.info(t('actions.procesing'))
            return serviciosService.delete(id)
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.deleted'));
                        get(item.id);
                    }
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => true)
        } else {
            toast.warning(t('auth.nopermit'))
        }

    }

    async function getPair(search) {
        if (authContext.verify({ pathname: "/cot" }, "GET")) {
            return cotizacionesService.getPersonas(search)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    appContext.errorHandler(error, toast, t);
                    return []
                })
        } else {
            toast.warning(t('auth.nopermit'));
            return []
        }

    }

    async function getPairResponsable(search) {
        if (authContext.verify({ pathname: "/cot" }, "GET")) {
            return cotizacionesService.getWorkers(search)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    appContext.errorHandler(error, toast, t);
                    return []
                })
        } else {
            toast.warning(t('auth.nopermit'));
            return []
        }

    }

    function calculate_montos() {
        let sum = 0;
        const montos = document.getElementsByName('monto_servicio');
        const montos_finales = document.getElementsByName('monto_total');
        const cants = document.getElementsByName('cantidad');
        for (let i = 0; i < montos.length; i++) {
            const monto = montos[i].value.replace(/\D/g, '');
            const cantidad = cants[i].value;
            let monto_final = (monto * cantidad)
            sum += monto_final
            montos_finales[i].value = appContext.formatCurrency(monto_final)
        }
        sum = appContext.formatCurrency(sum)
        document.getElementById('monto').value = sum
        value_adm_onchange()
        value_imp_onchange()
        value_uti_onchange()
        value_iva_onchange()
    }

    function defaultValue_monto(...data) {
        const i = data[1];
        const groups = data[2];
        const servicios = groups[1];
        if (!servicios) return '';
        if (!servicios.defaultValues[i]) return '';
        const input_data = servicios.defaultValues[i];
        const monto = input_data.monto;
        const cantidad = input_data.cantidad;
        const defaultValue = appContext.formatCurrency(monto * cantidad);
        return defaultValue;
    }

    function defaultValue_monto_base(...data) {
        const groups = data[2];
        const servicios = groups[1];
        if (!servicios) return false
        if (!servicios.defaultValues) return false;
        const input_data = servicios.defaultValues;
        let sum = 0;
        for (let i = 0; i < input_data.length; i++) {
            const monto = input_data[i].monto;
            const cantidad = input_data[i].cantidad;
            let monto_base = (monto * cantidad)
            sum += monto_base
        }
        return sum;
    }

    function value_adm(...data) {
        const sum = defaultValue_monto_base(...data)
        return appContext.formatCurrency(sum * Number(item.adm || 0) / 100);
    }

    function value_adm_onchange(e) {
        const value = document.getElementById('adm').value;
        const sum = appContext.deformatCurrency(document.getElementById('monto').value);
        document.getElementById('adm_value').value = appContext.formatCurrency(sum * Number(value) / 100);
        monto_subtotal()
    }

    function value_imp(...data) {
        const sum = defaultValue_monto_base(...data)
        return appContext.formatCurrency(sum * Number(item.imp || 0) / 100);
    }

    function value_imp_onchange(e) {
        const value = document.getElementById('imp').value;
        const sum = appContext.deformatCurrency(document.getElementById('monto').value);
        document.getElementById('imp_value').value = appContext.formatCurrency(sum * Number(value) / 100);
        monto_subtotal()
    }

    function value_uti(...data) {
        const sum = defaultValue_monto_base(...data)
        return appContext.formatCurrency(sum * Number(item.uti || 0) / 100);
    }

    function value_uti_onchange(e) {
        const value = document.getElementById('uti').value;
        const sum = appContext.deformatCurrency(document.getElementById('monto').value);
        document.getElementById('uti_value').value = appContext.formatCurrency(sum * Number(value) / 100);
        monto_subtotal()
    }

    function value_iva(...data) {
        const sum = defaultValue_monto_base(...data)
        const obj = {
            monto: sum, iva: item.iva, adm: item.adm, uti: item.uti, imp: item.imp,
        }
        return appContext.cotMontoIva(obj, true);
    }

    function value_iva_onchange(e) {
        const value = e ? e.target.value : item.imp
        const sum = appContext.deformatCurrency(document.getElementById('monto').value);
        const adm = appContext.deformatCurrency(document.getElementById('adm').value);
        const imp = appContext.deformatCurrency(document.getElementById('imp').value);
        const uti = appContext.deformatCurrency(document.getElementById('uti').value);
        const obj = {
            monto: sum, iva: value, adm, uti, imp,
        }
        document.getElementById('iva_value').value = appContext.cotMontoIva(obj, true);
        monto_subtotal()
    }

    function defaultValue_monto_subtotal(...data) {
        const sum = defaultValue_monto_base(...data)
        const adm = item.adm
        const imp = item.imp
        const uti = item.uti
        const value = sum + (sum * adm / 100) + (sum * imp / 100) + (sum * uti / 100)
        return appContext.formatCurrency(value);

    }

    function monto_subtotal() {
        const sum = appContext.deformatCurrency(document.getElementById('monto').value);
        const adm = appContext.deformatCurrency(document.getElementById('adm').value);
        const imp = appContext.deformatCurrency(document.getElementById('imp').value);
        const uti = appContext.deformatCurrency(document.getElementById('uti').value);
        const value = sum + (sum * adm / 100) + (sum * imp / 100) + (sum * uti / 100)
        document.getElementById('monto_subtotal').value = appContext.formatCurrency(value);
        monto_total()
    }

    function defaultValue_monto_total(...data) {
        const sum = defaultValue_monto_base(...data)
        const adm = item.adm
        const imp = item.imp
        const uti = item.uti
        const iva = item.iva
        const obj = {
            monto: sum, iva, adm, uti, imp,
        }

        const iva_monto = appContext.cotMontoIva(obj);
        const value = sum + (sum * adm / 100) + (sum * imp / 100) + (sum * uti / 100) + iva_monto
        return appContext.formatCurrency(value);

    }

    function monto_total() {
        const sum = appContext.deformatCurrency(document.getElementById('monto').value);
        const adm = appContext.deformatCurrency(document.getElementById('adm').value);
        const imp = appContext.deformatCurrency(document.getElementById('imp').value);
        const uti = appContext.deformatCurrency(document.getElementById('uti').value);
        const iva_value = appContext.deformatCurrency(document.getElementById('iva_value').value);
        const value = sum + (sum * adm / 100) + (sum * imp / 100) + (sum * uti / 100) + iva_value
        document.getElementById('monto_total').value = appContext.formatCurrency(value);

    }

    const codRegex = /^COT\.\d\d\d\.\d\d\d\d$/i;
    // const codRegexPro = /^\d\d\d\.\d\d\d\d$/i;
    // const cantFormat = (x) => Math.abs(Number(x).toFixed(0));

    useEffect(() => {
        if (modal) get(id);
    }, [modal]);


    const FORM = (i) => [
        {
            title: t('cotizacion.form.section_1'),
            inputs: [
                [
                    { id: "codigo", required: true, defaultValue: i?.codigo, title: t('cotizacion.form.codigo'), placeholder: t('cotizacion.form.codigo'), icon: "tag", pattern: codRegex, validateText: t('cotizacion.form.codigo_validate'), },
                    { id: "descripcion", defaultValue: i?.descripcion, title: t('cotizacion.form.descripcion'), placeholder: t('cotizacion.form.descripcion'), icon: "tag", },
                    { id: "fecha", required: true, defaultValue: i?.fecha, title: t('cotizacion.form.fecha'), placeholder: t('cotizacion.form.fecha'), type: "date", },
                    { id: "id_persona", required: true, defaultValue: i?.id_persona, defaultText: i?.nombre, title: t('cotizacion.form.id_persona'), placeholder: t('cotizacion.form.id_persona'), icon: "person", type: 'list', api: getPair, },
                ],
                [
                    { id: "intro", defaultValue: i?.intro || t('cotizacion.form.intro_dv'), title: t('cotizacion.form.intro'), placeholder: t('cotizacion.form.intro'), type: "textarea" },
                ],
                [
                    { id: "alcance", defaultValue: i?.alcance, title: t('cotizacion.form.alcance'), placeholder: t('cotizacion.form.alcance'), type: "textarea" },
                ],
                [
                    { id: "requerimientos", defaultValue: i?.requerimientos, title: t('cotizacion.form.requerimientos'), placeholder: t('cotizacion.form.requerimientos'), type: "textarea" },
                ],
                [
                    { id: "entregables", defaultValue: i?.entregables, title: t('cotizacion.form.entregables'), placeholder: t('cotizacion.form.entregables'), type: "textarea" },
                ],
                [
                    { id: "tiempo", defaultValue: i?.tiempo, title: t('cotizacion.form.tiempo'), placeholder: t('cotizacion.form.tiempo'), type: "textarea" },
                ],

            ]
        },
        {
            title: t('cotizacion.form.section_2'),
            multiple: true,
            hide: i ? false : true,
            defaultValues: i?.services,
            name: 'services',
            deleteApi: remove_service,
            deleteAllow: authContext.verify({ pathname: "/cot" }, "DELETE"),
            inputs: [
                [
                    // { component: <Servicios_Builder />, index: 'nombre', id: "nombre", },
                    { id: "nombre", index: 'nombre', title: t('servicios.form.nombre'), placeholder: t('servicios.form.nombre'), icon: "label", },
                    { id: "medida", index: 'medida', title: t('servicios.form.medida'), placeholder: t('servicios.form.medida'), icon: "cube", type: 'select', list: Vars.servicios_medidas.map(i => ({ value: i, text: t(`general.servicios_medidas.${i}`) })), width: '800px' },
                    { id: "cantidad", name: 'cantidad', index: 'cantidad', title: t('servicios.form.cantidad'), placeholder: t('servicios.form.cantidad'), icon: "cross", type: 'number', step: 0.01, defaultValue: Number(1), onBlur: calculate_montos, width: '700px' },
                    { id: "monto", name: 'monto_servicio', index: 'monto', title: t('servicios.form.monto'), placeholder: t('servicios.form.monto'), icon: "dollar", type: 'number', format: appContext.formatCurrency, onBlur: calculate_montos },
                    { id: "monto_total", name: 'monto_total', index: 'monto_total', title: t('servicios.form.monto_total'), placeholder: t('servicios.form.monto_total'), icon: "dollar", read: true, defaultValue: defaultValue_monto, disabled: true },
                    { type: 'emtpy', hide: i?.aprobado == false, width: '500px'},
                    { id: "id_tercero", index: 'id_tercero', text: 'persona', title: t('servicios.form.tercero'), placeholder: t('servicios.form.tercero'), icon: "person", type: 'list', api: getPair, hide: i?.aprobado == false },
                    { id: "monto_tercero", index: 'monto_tercero', title: t('servicios.form.monto_tercero'), placeholder: t('servicios.form.monto_tercero'), icon: "dollar", type: 'number', format: appContext.formatCurrency, hide: i?.aprobado == false },
                ],
            ]
        },
        {
            title: t("cotizacion.form.section_3"),
            hide: i ? false : true,
            inputs: [
                [
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { id: "monto", defaultValue: defaultValue_monto_base || i?.monto, title: t('cotizacion.form.monto'), placeholder: t('cotizacion.form.monto'), icon: "dollar", type: 'number', format: appContext.formatCurrency, hide: i ? false : true, read: true, },
                ],
                [
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { id: "adm", defaultValue: i?.adm, title: t('cotizacion.form.adm'), placeholder: t('cotizacion.form.adm'), icon: "percentage", type: 'percent', hide: i ? false : true, onChange: value_adm_onchange }, ,
                    { id: "adm_value", defaultValue: value_adm, title: t('cotizacion.form.adm'), placeholder: t('cotizacion.form.adm'), icon: "dollar", read: true, hide: i ? false : true, },
                ],
                [
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { id: "imp", defaultValue: i?.imp, title: t('cotizacion.form.imp'), placeholder: t('cotizacion.form.imp'), icon: "percentage", type: 'percent', hide: i ? false : true, onChange: value_imp_onchange, },
                    { id: "imp_value", defaultValue: value_imp, title: t('cotizacion.form.imp'), placeholder: t('cotizacion.form.imp'), icon: "dollar", read: true, hide: i ? false : true, },
                ],
                [
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { id: "uti", defaultValue: i?.uti, title: t('cotizacion.form.uti'), placeholder: t('cotizacion.form.uti'), icon: "percentage", type: 'percent', hide: i ? false : true, onChange: value_uti_onchange, },
                    { id: "uti_value", defaultValue: value_uti, title: t('cotizacion.form.uti'), placeholder: t('cotizacion.form.uti'), icon: "dollar", read: true, hide: i ? false : true, },
                ],
                [
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { id: "monto_subtotal", defaultValue: defaultValue_monto_subtotal, title: t('cotizacion.form.subtotal'), placeholder: t('cotizacion.form.subtotal'), icon: "dollar", type: 'number', read: true, hide: i ? false : true, },
                ],
                [
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { id: "iva", defaultValue: i?.iva, title: t('cotizacion.form.iva'), placeholder: t('cotizacion.form.iva'), icon: "percentage", type: 'percent', hide: i ? false : true, onChange: value_iva_onchange, },
                    { id: "iva_value", defaultValue: value_iva, title: t('cotizacion.form.iva'), placeholder: t('cotizacion.form.iva'), icon: "dollar", read: true, hide: i ? false : true, },
                ],
                [
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { id: "monto_total", defaultValue: defaultValue_monto_total, title: t('cotizacion.form.total'), placeholder: t('cotizacion.form.total'), icon: "dollar", type: 'number', read: true, hide: i ? false : true, },
                ]
            ]
        },
        {
            title: "",
            inputs: [
                [
                    { id: "pago", defaultValue: i?.pago || t('cotizacion.form.pago_dv'), title: t('cotizacion.form.pago'), placeholder: t('cotizacion.form.pago'), type: "textarea" },
                ],
                [
                    { id: "validez", defaultValue: i?.validez || t('cotizacion.form.validez_dv'), title: t('cotizacion.form.validez'), placeholder: t('cotizacion.form.validez'), type: "textarea" },
                ],
                [
                    { id: "observaciones", defaultValue: i?.observaciones, title: t('cotizacion.form.observaciones'), placeholder: t('cotizacion.form.observaciones'), type: "textarea" },
                ],
            ]
        },
        {
            title: "",
            inputs: [
                [
                    { id: "id_responsable", required: true, defaultValue: i?.id_responsable, defaultText: i?.responsable, title: t('cotizacion.form.responsable'), placeholder: t('cotizacion.form.responsable'), icon: "person", type: 'list', api: getPairResponsable, },
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                    { type: 'emtpy', },
                ],
            ]
        },
    ]

    const MODAL = (i) => <Dialog
        title={t('cotizacion.form.edit').replace('%VAR%', i.descripcion)}
        icon={"edit"}
        isOpen={modal} onClose={() => setModal(false)}
        className='modal-app'>
        <DialogBody useOverflowScrollContainer={true} >
            <FormComponent
                actions={{
                    primary: { icon: "edit", text: t('actions.edit') },
                    secondary: { icon: "cross", text: t('actions.close') }
                }}
                onSecondary={() => setModal(false)}
                onSubmit={(data) => edit(i.id, data)}
                groups={FORM(i)}
            />
        </DialogBody>
    </Dialog>


    return (
        <>
            {item ? MODAL(item) : null}
            <Tooltip content={t('actions.edit')} placement="top">
                <Button icon="edit" intent='warning' onClick={() => get(id, setModal)} />
            </Tooltip>
        </>
    );
}